import { memo, useCallback } from "react";
import { closeAllModals, openModal } from "@mantine/modals";
import CardReport from "../CardReport";
import TableReport from "./TableReport";
import {
  AccountReportInput,
  useDownloadAccountDetailReportLazyQuery,
} from "src/generated/graphql";
import useReport from "src/hooks/useReport";
import { downloadCSV } from "src/utils/utils";
import GetDetailInfo from "./GetDetailInfo";

const title = "Account Details";
function AccountDetailReport() {
  const { openDownloadModal, handleReportView } = useReport();

  const [downloadAccountDetailCsv] = useDownloadAccountDetailReportLazyQuery({
    onCompleted: () => {
      closeAllModals();
    },
  });

  const handleReportDownload = async (filters: AccountReportInput) => {
    openDownloadModal(title);
    const { data } = await downloadAccountDetailCsv({
      variables: {
        data: filters,
      },
    });

    downloadCSV(data?.downloadAccountDetailReport, "AccountDetailReport.csv");
  };

  const handleView = (values: AccountReportInput) => {
    handleReportView(<TableReport values={values} />);
  };

  const handleSubmit = (values: AccountReportInput, isdownload: boolean) => {
    closeAllModals();
    isdownload ? handleReportDownload(values) : handleView(values);
  };

  const handleModal = useCallback((isdownload: boolean) => {
    openModal({
      closeOnClickOutside: false,
      title,
      children: (
        <GetDetailInfo
          handleSubmit={(values) => handleSubmit(values, isdownload)}
        />
      ),
    });
  }, []);

  return <CardReport title={title} handleModal={handleModal} />;
}

export default memo(AccountDetailReport);
